/* assets/littleg-dashboard.js — LITTLEG-MY-CITY-JOURNEY-RUNTIME-01
 * Sole Dashboard tab visibility owner. Home projects verified local City Cards only.
 * No family notice, fake progress, direct storage keys, checkout or auth mutation.
 */

(function littleGDashboard(window, document) {
  'use strict';
  var VERSION = 'LITTLEG-MY-CITY-JOURNEY-RUNTIME-01';
  var GLOBAL_KEY = '__LITTLEG_DASHBOARD_RUNTIME__';
  var ROOT_SELECTOR = '[data-littleg-dashboard]';
  var TOOLS_SELECTOR = '[data-littleg-my-tools]';
  var ME_SELECTOR = '[data-littleg-my-profile-summary]';
  var PASSPORT_SELECTOR = '[data-map-passport]';
  var mounted = new Set();
  var scheduledFrame = null;

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function clean(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();
  }
  function all(scope, selector) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function readCityCards() {
    var family = window.LittleGFamilyData;
    if (!family || typeof family.livingCvSnapshot !== 'function') return null;
    try {
      var snapshot = family.livingCvSnapshot();
      return snapshot.status === 'ready' ? snapshot.records : null;
    } catch (_error) {
      return null;
    }
  }

  function savedAt(record) {
    return clean(
      record &&
        (record.updated_at ||
          record.confirmed_at ||
          record.saved_at ||
          record.created_at ||
          record.generated_at)
    );
  }
  function sourceLabel(record, locale) {
    var language = clean(locale).toLowerCase();
    var index = language.indexOf('en') === 0 ? 0 : /^zh-(cn|hans|sg)(-|$)/.test(language) ? 1 : 2;
    var labels = {
      'family-memory': ['Family memory', '家庭回忆', '家庭回憶'],
      'family-record': ['Family record', '家庭记录', '家庭紀錄'],
      'city-card': ['City memory card', '城市回忆卡', '城市回憶卡'],
      'living-cv': ['Personal record', '个人记录', '個人記錄'],
    };
    return (labels[clean(record && record.source_type)] || [
      'Saved record',
      '已保存记录',
      '已保存紀錄',
    ])[index];
  }
  function titleOf(record, locale) {
    var place = record && (record.location || record.place);
    var placeLabel =
      typeof place === 'string' ? place : clean(place && (place.label || place.name || place.text));
    return (
      clean(record && (record.mission_name || record.title || record.hero || placeLabel)) ||
      sourceLabel(record, locale)
    );
  }
  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = String(value);
  }

  function syncHomeActions(root, hasSavedCards) {
    var primary = root.querySelector('[data-dashboard-primary-action]');
    var secondary = root.querySelector('[data-dashboard-secondary-action]');

    if (primary) {
      primary.href = primary.dataset.cityHref;
      setText(primary, '[data-dashboard-primary-label]', primary.dataset.cityLabel);
    }

    if (secondary) secondary.hidden = !hasSavedCards;
  }

  function syncHome(root) {
    if (!root || !root.isConnected) return;
    var cards = readCityCards();
    var status = root.querySelector('[data-dashboard-status]');
    if (!status) return;
    if (cards === null) {
      syncHomeActions(root, false);
      root.dataset.dashboardHomeState = 'unavailable';
      root.dataset.dashboardRuntimeReady = 'false';
      root.dataset.dashboardRuntimeError = 'city-records-unavailable';

      var unavailableLatest = root.querySelector('[data-dashboard-latest-card]');
      var unavailableEmpty = root.querySelector('[data-dashboard-empty]');

      if (unavailableLatest) {
        unavailableLatest.hidden = true;
        unavailableLatest.replaceChildren();
      }
      if (unavailableEmpty) unavailableEmpty.hidden = true;

      // Unknown must never be presented as a verified empty record count.
      setText(root, '[data-dashboard-city-count]', '—');
      setText(root, '[data-dashboard-day-count]', '—');

      root.dataset.dashboardRuntimeState = 'unavailable';
      root.setAttribute('aria-busy', 'false');
      status.textContent =
        status.dataset.unavailableMessage || 'Saved city memories are unavailable.';
      return;
    }
    var days = new Set();
    cards.forEach(function (card) {
      var date = new Date(savedAt(card));
      if (!Number.isNaN(date.getTime())) {
        days.add(
          [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0'),
          ].join('-')
        );
      }
    });
    setText(root, '[data-dashboard-city-count]', cards.length);
    setText(root, '[data-dashboard-day-count]', days.size);
    var latest =
      cards.slice().sort(function (a, b) {
        var left = Date.parse(savedAt(a));
        var right = Date.parse(savedAt(b));
        return (Number.isFinite(right) ? right : 0) - (Number.isFinite(left) ? left : 0);
      })[0] || null;
    var latestNode = root.querySelector('[data-dashboard-latest-card]');
    var emptyNode = root.querySelector('[data-dashboard-empty]');
    if (latestNode) latestNode.hidden = !latest;
    if (emptyNode) emptyNode.hidden = Boolean(latest);
    syncHomeActions(root, Boolean(latest));
    if (latestNode) {
      latestNode.replaceChildren();
      var locale = clean(root.dataset.dashboardLocale) || 'zh-HK';
      cards
        .slice()
        .sort(function (a, b) {
          var left = Date.parse(savedAt(a)),
            right = Date.parse(savedAt(b));
          return (Number.isFinite(right) ? right : 0) - (Number.isFinite(left) ? left : 0);
        })
        .slice(0, 3)
        .forEach(function (record) {
          var row = document.createElement('li');
          var label = document.createElement('strong');
          label.textContent = titleOf(record, locale);
          row.append(label);
          var saved = savedAt(record);
          if (saved && Number.isFinite(Date.parse(saved))) {
            var date = document.createElement('time');
            date.dateTime = new Date(saved).toISOString();
            date.textContent = new Intl.DateTimeFormat(root.dataset.dashboardLocale || 'zh-HK', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            }).format(new Date(saved));
            row.append(date);
          }
          var source = document.createElement('small');
          source.textContent = sourceLabel(record, locale);
          row.append(source);
          latestNode.append(row);
        });
    }

    var offline = window.navigator && window.navigator.onLine === false;
    root.dataset.dashboardRuntimeState = offline ? 'offline' : 'ready';
    root.dataset.dashboardRuntimeReady = 'true';
    root.dataset.dashboardRuntimeError = '';
    root.dataset.dashboardHomeState = latest ? 'saved' : 'empty';
    root.setAttribute('aria-busy', 'false');
    status.textContent = offline ? status.dataset.offlineMessage || '' : '';
  }
  function tab() {
    try {
      var value = clean(new URL(window.location.href).searchParams.get('tab')).toLowerCase();
      return value === 'tools' || value === 'me' || value === 'passport' ? value : 'home';
    } catch (_error) {
      return 'home';
    }
  }
  function setSurfaceVisible(root, visible, owner) {
    root.hidden = !visible;
    root.inert = !visible;
    if (!visible)
      all(root, 'dialog[open]').forEach(function (sheet) {
        sheet.close();
      });
    root.setAttribute('aria-hidden', visible ? 'false' : 'true');
    var wrapper = root.closest && root.closest('.shopify-section');
    if (wrapper) {
      // The Home section also owns the persistent four-tab navigation.
      wrapper.hidden = root.matches(ROOT_SELECTOR) ? false : !visible;
      wrapper.setAttribute(
        'aria-hidden',
        root.matches(ROOT_SELECTOR) || visible ? 'false' : 'true'
      );
      wrapper.setAttribute('data-dashboard-tab-owner', owner);
    }
  }
  function syncDashboardTab(active) {
    document.documentElement.setAttribute('data-littleg-dashboard-tab', active);
    if (document.body) document.body.setAttribute('data-littleg-dashboard-tab', active);
    all(document, '[data-dashboard-tab-link]').forEach(function (link) {
      var selected = link.getAttribute('data-dashboard-tab-link') === active;
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    // Profile remains a private panel, entered via the header account link.
    all(document, '[data-dashboard-profile-entry]').forEach(function (link) {
      if (active === 'me') link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    all(document, ROOT_SELECTOR).forEach(function (root) {
      setSurfaceVisible(root, active === 'home', 'home');
    });
    all(document, TOOLS_SELECTOR).forEach(function (root) {
      setSurfaceVisible(root, active === 'tools', 'tools');
    });
    all(document, ME_SELECTOR).forEach(function (root) {
      setSurfaceVisible(root, active === 'me', 'me');
    });
    all(document, PASSPORT_SELECTOR).forEach(function (root) {
      // A legacy standalone Passport page must never be hidden by Dashboard's tab owner.
      if (!document.querySelector(ROOT_SELECTOR)) return;
      setSurfaceVisible(root, active === 'passport', 'passport');
    });
  }
  function routeClick(event) {
    var link =
      event.target.closest &&
      event.target.closest('[data-dashboard-tab-link], [data-dashboard-profile-entry]');
    if (
      !link ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    if (link.hasAttribute('data-dashboard-map-entry')) {
      try {
        window.sessionStorage.setItem('littleg-map-dashboard-entry-v1', String(Date.now()));
      } catch (_) {}
      return; // Preserve the native cross-page link, including its query string.
    }
    var destination = new URL(link.href, window.location.href);
    if (
      destination.origin !== window.location.origin ||
      destination.pathname !== window.location.pathname
    )
      return;
    event.preventDefault();
    var url = new URL(window.location.href);
    url.searchParams.set(
      'tab',
      link.hasAttribute('data-dashboard-profile-entry') ? 'me' : link.dataset.dashboardTabLink
    );
    window.history.pushState(window.history.state, '', url);
    sync();
  }
  document.addEventListener('click', routeClick);
  function sync() {
    scheduledFrame = null;
    var active = tab();
    syncDashboardTab(active);
    if (active === 'home') mounted.forEach(syncHome);
    var focused = document.activeElement;
    if (focused && focused.closest && focused.closest('[hidden], [inert]')) {
      var activeLink =
        document.querySelector('[data-dashboard-tab-link="' + active + '"]') ||
        (active === 'me' ? document.querySelector('[data-dashboard-profile-entry]') : null);
      if (activeLink) activeLink.focus({ preventScroll: true });
    }
    document.dispatchEvent(
      new CustomEvent('littleg:dashboard-tab-change', { detail: { tab: active } })
    );
  }
  function schedule() {
    if (scheduledFrame !== null) return;
    scheduledFrame = window.requestAnimationFrame(sync);
  }
  function bind(root) {
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    root.dataset.dashboardRuntimeBound = VERSION;
    root.dataset.dashboardRuntimeReady = 'false';
    root.dataset.dashboardRuntimeState = 'loading';
    root.dataset.dashboardRuntimeError = '';
    root.dataset.dashboardHomeState = 'loading';
    schedule();
  }
  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) bind(target);
    all(target, ROOT_SELECTOR).forEach(bind);
    schedule();
  }
  function destroy(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mounted.delete(target);
    all(target, ROOT_SELECTOR).forEach(function (root) {
      mounted.delete(root);
    });
    schedule();
  }
  [
    'littleg:family-data-ready',
    'littleg:family-data-cleared',
    'littleg:cv-change',
    'littleg:family-record-saved',
    'littleg:family-social-graph-change',
    'littleg:family-cloud-sync',
    'littleg:parent-gate-change',
    'littleg:profile-change',
    'littleg:web-session-change',
  ].forEach(function (name) {
    document.addEventListener(name, function () {
      if (name === 'littleg:web-session-change')
        mounted.forEach(function (root) {
          var node = root.querySelector('[data-dashboard-latest-card]');
          if (node) {
            node.replaceChildren();
            node.hidden = true;
          }
        });
      schedule();
    });
  });
  [
    'littleg:city-mission:result-saved',
    'littleg:city-mission:result-updated',
    'littleg:city-mission:result-removed',
    'littleg:city-mission:results-cleared',
  ].forEach(function (name) {
    window.addEventListener(name, schedule);
  });
  ['online', 'offline', 'pageshow', 'popstate'].forEach(function (name) {
    window.addEventListener(name, schedule);
  });
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target || document);
  });
  window[GLOBAL_KEY] = { version: VERSION, boot: boot, sync: schedule, destroy: destroy };
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }
})(window, document);
